import { RouteService } from './route-service';

let routeService = new RouteService();

export { routeService }